export default __webpack_public_path__ + "static/media/img9.74610a39.PNG";